import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { ClientList } from 'modules/clientList';
import { Forbidden, NotFound } from 'modules/common';
import ProtectedRoute from './ProtectedRoute';
import { User } from '../../types/api/user';
import { Role } from '../../types/api/user/dictionaries';

interface Props {
  user?: User;
}

export default function Router({ user }: Props) {
  return (
    <>
      <Switch>
        <Redirect exact from="/" to="/client-list" />

        <ProtectedRoute
          forRole={[Role.Moderator, Role.Partner]}
          exact
          component={ClientList}
          path="/client-list"
        />

        <Route exact component={Forbidden} path="/forbidden" />
        <Route component={NotFound} />
      </Switch>
    </>
  );
}
